import EnhanceLoadable from "./EnhanceLoadable";
import DefaultLoading from "./DefaultLoading";

const Loadable = (isLoaded, LoadingComponent = DefaultLoading) =>
  EnhanceLoadable(isLoaded, LoadingComponent);

export default Loadable;
